module.exports = __webpack_public_path__ + "static/img/confetti.1dd48b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/confetti.png
// module id = +82Z
// module chunks = 0